import React, {useEffect, useState} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import Billing from "../../components/MyProfile/Billing";
import GeneralInformation from "../../components/MyProfile/GeneralInformation";
import Payout from "../../components/MyProfile/Payout";
import Verification from "../../components/MyProfile/Verification/Index";
import Tabination from "../../reusableComponents/Tabination";
import "./style.scss";
import MainHeader from "../../layouts/pageLayout/MainHeader";

function MyProfile() {
  const [activeTab, setActiveTab] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeTab]);
  const items = [
    {
      name: "General Information",
      path: "general-information",
    },
    {
      name: "Verification",
      path: "verification",
    },
    {
      name: "Billing",
      path: "billing",
    },
    // {
    //   name: "Payout",
    //   path: "payout",
    // },
  ];

  return (
    <>
      <div className="myprofileContainer">
        <h4 className="myprofile_header">Account Details</h4>
        <Routes>
          <Route
            path="/"
            element={
              <Navigate
                to="general-information"
                replace={true}
              />
            }
          />
          <Route
            path="general-information"
            element={<GeneralInformation />}
          />
          <Route
            path="*"
            element={
              <Navigate
                to="/"
                replace={true}
              />
            }
          />
        </Routes>
      </div>
    </>
  );
}

export default MyProfile;
